import MetaTags from "../../components/MetaTags";
import VouchersRedeem from "../../features/web/vouchers/VouchersRedeem";

function RedeemedLectures() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | الشراء عن طريق الكود"
                description="صفحة الشراء عن طريق الكود على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <VouchersRedeem />
        </>
    );
}

export default RedeemedLectures;
